import { initGraphQLTada } from 'gql.tada';

import { AWSAccessProviderType, StatusType } from './enums';
import type { introspection } from './graphql-env';

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    Long: number;
    AwsAccessProviderType: AWSAccessProviderType;
    ReleaseStatus: StatusType;
  };
}>();
